import React, { Component } from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { ShowIf, NoContent } from 'components/utils';
import { BusinessForwardChoosedItem } from 'components/business';

class BusinessForwardChoosedList extends Component {
  static propTypes = {
    onRemove: PropTypes.func.isRequired,
    data: PropTypes.array.isRequired
  }

  static defaultProps = {
    data: []
  }

  render() {
    const { data } = this.props;
    if (!data) {
      return null;
    }

    return (
      <div className="choosed-list">
        <ShowIf condition={data.length === 0}>
          <NoContent content="Bạn chưa chọn doanh nghiệp nào" height={300}/>
        </ShowIf>
        <ShowIf condition={data.length > 0}>
          <table className="table table-striped businesses-forward-table">
            <thead className="thead">
              <tr className="tr-head">
                <th className="col-lg-1">
                  #
                </th>
                <th className="col-lg-8">
                  Doanh nghiệp
                </th>
                <th className="col-lg-3 text-center">
                  Hành động
                </th>
              </tr>
            </thead>
            <tbody className="tbody">
              {data.map((item, i) => (
                <BusinessForwardChoosedItem
                  key={item.id}
                  data={item}
                  index={i+1}
                  onRemove={this.props.onRemove}/>
              ))}
            </tbody>
          </table>
        </ShowIf>
      </div>
    );
  }
}

export default BusinessForwardChoosedList;


// WEBPACK FOOTER //
// ./components/business/BusinessForwardChoosedList.jsx